import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import ContactNameRenderer from '../../../../components/table-cells/ContactNameRenderer';
import DateRenderer from '../../../../components/table-cells/DateRenderer';
import EmailRenderer from '../../../../components/table-cells/EmailRenderer';

import {
  fetchFeedbackExcludedContacts,
} from '../../../Dashboard/DashboardActions';


import {
  getContactExclusionLoading,
  getContactExclusionLoaded,
  getContactExclusionErrors,
  getContactExclusions,
} from '../../../Dashboard/DashboardReducer';


class ContactList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getColDefs = this.getColDefs.bind(this);
    this.columnContactValueGetter = this.columnContactValueGetter.bind(this);
  }

  componentDidMount() {
    const ids = map(this.props.opportunities, 'opportunity_id');
    if (ids.length > 0) {
      this.props.dispatch(fetchFeedbackExcludedContacts(ids));
    }
  }

  columnContactValueGetter(params) {
    if (params.node.group) {
      // groupping
      return null;
    }
    const { data } = params;
    return `${data.first_name} ${data.last_name}`;
  }

  getColumn(column, field) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field,
      enableRowGroup: true,
      enablePivot: true,
      cellRendererParams: {
        column,
      },
    };
  }

  getContactColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      valueGetter: this.columnContactValueGetter,
      cellRenderer: 'contactNameRenderer',
      cellRendererParams: {
        column,
      },
    };
  }


  getDateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      field: 'last_contact_status_updated',
      cellRenderer: 'dateRenderer',
      cellRendererParams: {
        column,
        format: 'shortWithTime',
      },
    };
  }


  getEmailColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      enablePivot: true,
      field: 'email',
      cellRenderer: 'emailRenderer',
      cellRendererParams: {
        column,
      },
    };
  }

  getColDefs(tableColumn) {
    if (tableColumn.tag === 'contact') {
      return this.getContactColumn(tableColumn);
    }
    if (tableColumn.tag === 'terminatedDate') {
      return this.getDateColumn(tableColumn);
    }
    if (tableColumn.tag === 'title') {
      return this.getColumn(tableColumn, 'title');
    }
    if (tableColumn.tag === 'email') {
      return this.getEmailColumn(tableColumn);
    }
    if (tableColumn.tag === 'terminatedReason') {
      return this.getColumn(tableColumn, 'terminated_reason');
    }
    if (tableColumn.tag === 'notes') {
      return this.getColumn(tableColumn, 'notes');
    }
    return null;
  }

  renderResults() {
    const { contacts } = this.props;
    if (!contacts || contacts.length === 0) {
      return (
        <div className="alert alert-warning">
          No contacts found.
        </div>
      );
    }
    return (
      <OpportunityTable
        opportunities={this.props.contacts}
        tableName="feedback-contact-excluded-table"
        title={null}
        getColDefs={this.getColDefs}
        frameworkComponents={{
          // exclusionRenderer: ExclusionRenderer,
          contactNameRenderer: ContactNameRenderer,
          dateRenderer: DateRenderer,
          emailRenderer: EmailRenderer,
        }}
      />
    );
  }

  render() {
    const {
      loaded, loading,
    } = this.props;
    const isLoading = !loaded || loading;

    return (
      <div>
        {isLoading && <ProgressBar />}
        {loaded && !loading && this.renderResults()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getContactExclusionLoading(state),
    loaded: getContactExclusionLoaded(state),
    errors: getContactExclusionErrors(state),
    contacts: getContactExclusions(state),
  };
}

ContactList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  errors: PropTypes.shape({}),
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
};

ContactList.defaultProps = {
  loading: false,
  loaded: false,
  errors: null,
  contacts: [],
  opportunities: [],
};

ContactList.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(ContactList);
